import { Coords } from 'model';

export function getDistance(c1: Coords, c2: Coords): number {
  return google.maps.geometry.spherical.computeDistanceBetween(
    new google.maps.LatLng(c1.latitude, c1.longitude),
    new google.maps.LatLng(c2.latitude, c2.longitude),
  )
}
